const validateDate = function (date) {
    let dateInstance = new Date(date);
    let isValid = true;
    try {
        isValid = dateInstance.toISOString().indexOf(date.replace("Z", "")) !== -1;
    }
    catch (err) {
        isValid = false;
    }
    return isValid;
};
export const isValidISODate = function (date) {
    let match = date !== null && date !== undefined ? date.match(/(\d+)-(\d+)-(\d+)T(\d+):(\d+):(\d+)\.?(\d*)/i) : [];
    return match !== null && match.length !== 0 && validateDate(date);
};
//# sourceMappingURL=isValidISODate.js.map